/**
 * 메시지 타입 정의
 */
export type MessageType = string;

/**
 * 메시지 출처 상수 정의
 */
const SOURCES = {
  IGB: "igbMessage", // IGB에서 보낸 메시지
};

export const igbSendMessage = <T>(
  type: MessageType,
  data?: T,
  logEnabled?: boolean
): void => {
  window.postMessage(
    {
      source: SOURCES.IGB,
      detail: { type, data },
    },
    "*"
  );

  // window.parent가 자기 자신이 아닐 때만 호출
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        source: SOURCES.IGB,
        detail: { type, data },
      },
      "*"
    );
  }

  // 로그 출력 여부 결정 (파라미터가 없으면 개발 환경에서만 출력)
  const shouldLog =
    logEnabled ?? import.meta.env.VITE_APP_MODE !== "production";

  if (shouldLog) {
    console.warn("📤 IGB message sent:", { type, data });
  }
};
